import { ManagePaymentInformation } from '../../features/payments/components/ManagePaymentInformation/ManagePaymentInformation';

export function DemoPage() {
  return <ManagePaymentInformation />;
}

export default DemoPage;
